import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enLocales from "./en.json";
import heLocales from "./he.json";

const lng = "he";
i18n.use(initReactI18next).init({
  resources: {
    en: { translations: enLocales },
    he: { translations: heLocales },
  },
  lng,
  fallbackLng: { default: ["he"] },
  debug: false,
  ns: ["translations"],
  defaultNS: "translations",
  interpolation: {
    escapeValue: false,
  },
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    transWrapTextNodes: "",
  },
});
